import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID,TransferState, makeStateKey } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// services
import { SessionService } from '../../../shared/services/session.service';
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { UPDATE_USER_EMAIL_TOKEN, UPDATE_USER_EMAIL_TOKEN_VALID, UPDATE_USER_SHOW_TOAST } from '@shared/reducers/user.reducer';
import { FormsModule } from '@angular/forms';

const TOKEN_DATA = makeStateKey('token_data');
const SESSION_ID = makeStateKey('session_id');

@Component({
  selector: 'app-verify-section',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './verify-section.component.html',
  styleUrls: ['./verify-section.component.scss'],
})
export class VerifySectionComponent implements OnInit, OnDestroy {

  private _tokenStoreData: any;
  private _tokenDataSubscription: Subscription;
  private _sessionDataSubscription: Subscription;
  private _sessionId = null;

  constructor(
    private _appStore: Store<AppState>,
    private _sessionService: SessionService,
    private _loginService: LoginService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _serverState: TransferState,
    private _errorService: ErrorHandler
  ) { }

  ngOnInit() {

    if (isPlatformServer(this.platformId)) {
      this._tokenDataSubscription = this._sessionService.tokenDataReturned$
        .subscribe(hasData => {
          if (hasData === true) {
            const tokenData: any = this._sessionService.getQueryTokenData();
            this._serverState.set(TOKEN_DATA, tokenData as any);
          }
        });
      this._sessionDataSubscription = this._sessionService.sessionDataReturned$
        .subscribe(hasData => {
          if (hasData === true) {
            const sessionId: string = this._sessionService.getQuerySessionId();
            this._serverState.set(SESSION_ID, sessionId as any);
          }
        });
    } else {

      try {

        const tokenData = this._serverState.get(TOKEN_DATA, null as any);
        this._sessionId = this._serverState.get(SESSION_ID, null as any);

        // if error returned
        if (tokenData.hasError) {
          this._appStore.dispatch(UPDATE_USER_EMAIL_TOKEN_VALID({ userEmailTokenValid: false }));
          this._errorService.handleError(tokenData.data);

          setTimeout(() => {
            // redirect with session data
            this._router.routeReuseStrategy.shouldReuseRoute = function(){ return false; };
            const currentUrl = this._router.url;
            this._router.navigateByUrl(currentUrl)
              .then(() => {
                this._router.navigated = false;
                window.open('flight-finder/search?session=' + this._sessionId, '_self');
              });
          }, 1500);
        } else {
          this._tokenStoreData = tokenData.data.tokenData;
          this._tokenStoreData.token = tokenData.data.urlToken;
          this._tokenStoreData.accessToken = tokenData.data.token;

          this._appStore.dispatch(UPDATE_USER_EMAIL_TOKEN({ userEmailToken: this._tokenStoreData }));
          this._appStore.dispatch(UPDATE_USER_EMAIL_TOKEN_VALID({ userEmailTokenValid: true }));

          this.redirectUser();
        }
      } catch (err) {
        // console.log('IN CATCH');
        this._router.navigate(['flight-finder/search'], {queryParams: {'start-booking': true}});
      }
    }

  }

  redirectUser() {
    const userLoggedIn = this.getState(this._appStore).userReducer.userDetails.userLoggedIn;

    if (this._tokenStoreData.tokenType === '01') {
      this._router.navigate(['set-password']);
    } else if (this._tokenStoreData.tokenType === '02') {
      const url = environment.trackUrl + '?bookingref='
        + this._tokenStoreData.bookingReference
        + '&email=' + this._tokenStoreData.emailAddress !== null
          ? this._tokenStoreData.emailAddress : '';

      window.location.replace(url+'&referrer=bookingFunnel');
    } else if (this._tokenStoreData.tokenType === '03') {
      if (!userLoggedIn) {
        this._router.navigate(['login'],
        { queryParams: { redirect: 'my-account/bookings/booking-details', ref: this._tokenStoreData.bookingReference }});
      } else {
        this._router.navigate(['my-account/bookings/booking-details'], { queryParams: { ref: this._tokenStoreData.bookingReference }});
      }

    // magic link
    } else if (this._tokenStoreData.tokenType === '06') {

      // if magic link valid, login
      if (this._tokenStoreData) {
        const storeCookie = true;
        const isGuest = false;

        const token = this._tokenStoreData.accessToken;
        const parsedToken = this.parseReturnedData(token);

        this._loginService.loginAccessToken(parsedToken.access_token, storeCookie, isGuest);

        this._appStore.dispatch(UPDATE_USER_SHOW_TOAST({ userShowToast: true }));
      }

      setTimeout(() => {
        // redirect with session data
        this._router.routeReuseStrategy.shouldReuseRoute = function(){ return false; };
        const currentUrl = this._router.url;
        this._router.navigateByUrl(currentUrl)
          .then(() => {
            this._router.navigated = false;
            window.open('flight-finder/search?session=' + this._sessionId, '_self');
          });
      }, 1500);
    }

  }

  parseReturnedData(value: any) {
    const parsed = JSON.parse(value);
    return parsed;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    if (this._tokenDataSubscription) { this._tokenDataSubscription.unsubscribe(); }
    if (this._sessionDataSubscription) { this._sessionDataSubscription.unsubscribe(); }
  }

}
